class ProductFormSubmit extends HTMLElement {
  constructor() {
    super();

    this.style.display = "block";

    const elements = {
      form: this.closest("form"),
      button: this.querySelector("button")
    };

    elements.selling_plan = elements.form.querySelector("[name=selling_plan]");

    elements.button.addEventListener("click", (event) => {
      event.preventDefault();

      elements.button.classList.add("state--loading");

      const data = new FormData(elements.form);

      if (elements.selling_plan && elements.selling_plan.disabled) {
        data.set("selling_plan", "");
      }

      fetch("/cart/add.js", {
        method: "POST",
        body: data
      })
      .then(response => {
        return response.json().then(body => {
          if (!response.ok) {
            throw new Error(body.description || body.message || response.statusText);
          }

          return body;
        });
      })
      .then(response => {
        document.dispatchEvent(new CustomEvent("addtocart", {
          detail: response
        }));
        elements.button.classList.remove("state--loading");
      })
      .catch(error => {
        elements.button.classList.remove("state--loading");
        console.error("ProductFormSubmitError: ", error);
      });
    });
  }
}

customElements.define("product-form-submit", ProductFormSubmit);
